var r=function(r){var n;for(n in r)return!1;return!0};export{r as default};
